// frontend/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ role, roles, children }) => {
  const token = localStorage.getItem('authToken');
  if (!token) return <Navigate to="/login" replace />;

  try {
    const user = jwtDecode(token);
    const userRole = user.role?.toLowerCase();

    if (roles && roles.length > 0) {
      if (!roles.some(r => r.toLowerCase() === userRole)) {
        return <Navigate to="/login" replace />;
      }
    } else if (role && userRole !== role.toLowerCase()) {
      return <Navigate to="/login" replace />;
    }
  } catch (err) {
    console.error('Token decoding failed:', err);
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
